module.exports = __webpack_public_path__ + "img/branding-logo-huisstijl-full-on-eventsector-3.0ab4113b.jpg";